import {ImageRequestParams} from "../../models/image/image-request-params";
export class TopScorerSelectedImageRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `bolao26/Icons/Top_Scorer_Selected`;
    this.ratio = 3;
  }
}
